export { default } from '../utils/translateModel';
